/**
 * Created by mqamhieh on 7/19/18.
 */
(function () {

    "use strict";

    angular
        .module('components')
        .component('hBrandNavigator', {
            controller: HBrandNavigatorComponent,
            controllerAs: 'hBrandNavigatorComponent',
            bindings: {
                name: '@',
                hName: '@',
                ngModel: '=',
                brandId: '<',
                singleSelect: '<',
                onLoadBrand: '&',
                ngChange: '&',
                brandsDisabled: '<',
                separateEnterprise: '<',
                alwaysCheckRoot: '<',
                onBrandMappingsChange: '&',
                brandMappings: '<',
                enterpriseLevelOnly: '<',
                onInitTree: '&',
                onSearchTreeLoaded: '&',
                hideSearch: '<',
                includeArchivedLocations: '<',
                showClosedLocationsToggle: '<',
                onClosedLocationsToggleChange: '&',
            },
            templateUrl: '../hmodules/components/h-brand-navigator/h-brand-navigator.component.ng.html'
        });

    HBrandNavigatorComponent.$inject = ['$scope', '$element', '$q', '$timeout', 'brandNavigatorService'];

    function HBrandNavigatorComponent($scope, $element, $q, $timeout, brandNavigatorService) {

        var self = this;
        self.searchResults = [];


        self.activeLevels = [];
        var FIRST_TREE_LEVEL = 1;
        self.searchDebounceValue = 500;
        self.loadingBrandTree = true;

        var initBrandNavigatorTree = function () {
            self.name = self.name || self.hName;

            if (self.brandMappings) {
                unSetActiveInBrandMappings();
                var rootBrand = getTreeRootBrand(self.brandMappings[self.brandId]);
                self.brandId = rootBrand.id;
            }
            else {
                self.brandMappings = {};
            }
            var returnMap = {};
            var initializePromise = self.onInitTree({'returnMap': returnMap }) || returnMap['promise'];
            if (initializePromise && initializePromise.then) {
                initializePromise
                    .then(function (initialTreeData) {
                        if (angular.isArray(initialTreeData)) {
                            initialTreeData = initialTreeData[0];
                        }
                        addTreeIntoMappingBrands(initialTreeData);
                        for (var i in self.ngModel) {
                            updateChildrenRecursive(self.ngModel[i].id);
                        }
                        for (var i in self.ngModel) {
                            updateParentsRecursive(self.ngModel[i].id);
                        }

                        self.setActive(0, self.brandId)
                            .then(function () {
                                rebuildModel(true);
                            })
                            .finally(function () {
                                self.loadingBrandTree = false;
                            });
                    })
                    .catch(function (err) {
                        console.error(err);
                        self.setActive(0, self.brandId)
                            .finally(function () {
                                self.loadingBrandTree = false;
                            });
                    });
            } else {
                self.setActive(0, self.brandId)
                    .finally(function () {
                        self.loadingBrandTree = false;
                    });
            }
        };

        self.$onInit = function () {
            initBrandNavigatorTree();
        };

        self.$onDestroy = function () {
            brandNavigatorService.reset();
        };

        var addTreeIntoMappingBrands = function (brand) {
            var brandId = brand.id;
            self.brandMappings[brandId] = brand;

            self.brandMappings[brandId].brand_id = brandId;

            matchModelIntoBrandsTree(brandId);

            for (var i in brand.brands) {
                var childBrand = brand.brands[i];
                childBrand.parent_id = brandId;
                addTreeIntoMappingBrands(childBrand);
            }
        };

        var matchModelIntoBrandsTree = function (brandId) {
            if (!angular.isArray(self.ngModel)) {
                self.ngModel = [];
            }

            if (angular.isArray(self.ngModel)) {
                for (var i in self.ngModel) {
                    var selectedBrand = self.ngModel[i];

                    if (selectedBrand.id === brandId) {
                        self.brandMappings[brandId].selected = true;

                        if (selectedBrand.type) {
                            self.brandMappings[brandId].type = selectedBrand.type;
                        }
                    }
                }
            }
        };

        var unSetActiveInBrandMappings = function () {
            for (var i in self.brandMappings) {
                self.brandMappings[i].active = false;
            }
        };

        var rebuildModel = function (startClean) {
            if (startClean || !angular.isArray(self.ngModel)) {
                self.ngModel = [];
            }

            for (var i = self.ngModel.length - 1; i >= 0; i--) {
                var selectedBrandFromModel = self.ngModel[i];
                if (self.brandMappings[selectedBrandFromModel.id]) {
                    self.ngModel.splice(i, 1);
                }
            }
            getSelectedRecursive(self.ngModel, [self.rootBrand]);
        };

        var getSelectedRecursive = function (appendToArray, brands) {

            if (brands) {
                for (var i in brands) {
                    var isEnterpriseAsChild = (typeof (brands[i].id) === "string" && brands[i].id.indexOf("child_") === 0);
                    var brandId = (typeof (brands[i].brand_id) === "string" && brands[i].brand_id.indexOf("child_") === 0) ? parseInt(brands[i].brand_id.replace("child_", "")) : brands[i].brand_id;

                    if (brands[i].selected) {
                        appendToArray.push({
                            id: brandId,
                            name: brands[i].name,
                            include_children: brands[i].type !== 'child',
                            type: isEnterpriseAsChild? 'enterprise': brands[i].type,
                            access_type: brands[i].access_type,
                            children_access_status: brands[i].children_access_status,
                            parent_id: brands[i].parent_id
                        });
                    }
                    else {
                        getSelectedRecursive(appendToArray, brands[i].brands);
                    }
                }
            }
        };

        var updateChildrenRecursive = function (brandId) {
            var brandInAction = self.brandMappings[brandId];

            if (brandInAction && brandInAction.brands) {
                var isParentSelected = brandInAction.selected;

                if (!isParentSelected) {
                    brandInAction.partially_selected = false;
                }

                for (var i in brandInAction.brands) {
                    var childBrand = brandInAction.brands[i];
                    childBrand.selected = isParentSelected;
                    updateChildrenRecursive(childBrand.id);
                }
            }
        };

        var updateParentsRecursive = function (brandId) {
            var brandInAction = self.brandMappings[brandId];

            if (brandInAction && brandInAction.parent_id) {
                var parentBrand = self.brandMappings[brandInAction.parent_id];
                var isAllChildrenSelected = true;
                var atLeastOneSelected = false;

                for (var i in parentBrand.brands) {
                    if (!parentBrand.brands[i].selected) {
                        isAllChildrenSelected = false;
                    }

                    atLeastOneSelected = atLeastOneSelected || parentBrand.brands[i].partially_selected || parentBrand.brands[i].selected;
                }

                if (parentBrand.selected && !isAllChildrenSelected) {
                    parentBrand.selected = false;
                }

                parentBrand.partially_selected = atLeastOneSelected;

                updateParentsRecursive(brandInAction.parent_id);
            }
        };

        self.brandSelectionChanged = function (brandId) {
            if (self.singleSelect === true) {
                for (var i in self.brandMappings) {
                    if (i != brandId) {
                        self.brandMappings[i].selected = false;
                    }
                    else {
                        self.ngModel = self.brandMappings[brandId].selected? { id: brandId }: null;
                    }
                }
            }
            else {

                updateChildrenRecursive(brandId);
                updateParentsRecursive(brandId);

                rebuildModel();
            }

            $scope.$evalAsync();
            self.onBrandMappingsChange({'brand_mappings': angular.copy(self.brandMappings)});
            $element.find("input[type='text']").change();
            self.ngChange();
        };

        var resetActiveBrands = function (level) {
            if (level > 0) {
                for (var i = level - 1; i < self.activeLevels.length; i++) {
                    for (var j in self.activeLevels[i]) {
                        var id = self.activeLevels[i][j].id;
                        if (self.brandMappings[id]) {
                            self.brandMappings[id].active = false;
                            self.brandMappings[id].activeSearchResult = false;
                        }
                    }
                }
            }
        };

        var filterActiveLevels = function (activeLevels, level) {
            var filteredActiveLevels = angular.copy(activeLevels);
            var length = filteredActiveLevels.length - 1;

            for (var i = length; i > level; i--) {
                filteredActiveLevels.splice(i, 1);
            }

            return filteredActiveLevels;
        };

        self.setActive = function (level, brandId, searchMode) {
            var defer = $q.defer();

            //Return when the target brand is active and have loaded children brands
            if (
                self.brandMappings[brandId] &&
                self.brandMappings[brandId].active &&
                self.brandMappings[brandId].brands &&
                self.brandMappings[brandId].brands.length
            ) {
                defer.resolve();
                return defer.promise;
            }

            if (!searchMode) {
                resetActiveBrands(level);
            }

            getBrand(brandId, searchMode)
                .then(function (brandTree) {
                    brandId = brandTree.id || brandId;
                    if (self.canExpandTree(brandTree) || (level === 0)) {
                        self.brandMappings[brandId].active = true;
                        self.activeLevels[level] = null;

                        $timeout(function () {
                            if (level === 0) {
                                self.rootBrand = brandTree;
                            }

                            self.activeLevels[level] = brandTree.brands;
                            defer.resolve();
                        }, 300);

                        if (!searchMode) {
                            self.activeLevels = filterActiveLevels(self.activeLevels, level);
                        }
                    }
                    else {
                        if (!self.brandMappings[brandId].disabled && searchMode) {
                            // Searching for child brand when we can view enterprise only , highlight enterprise
                            self.brandMappings[brandId].activeSearchResult = true;
                            $scope.$evalAsync();
                        } else if (!self.brandMappings[brandId].disabled && !self.brandsDisabled) {
                            self.brandMappings[brandId].selected = !self.brandMappings[brandId].selected;
                            self.brandSelectionChanged(brandId, self.brandMappings[brandId].selected);
                        }
                        defer.resolve();
                    }
                });

            return defer.promise;
        };

        var getTreeRootBrand = function (brand) {

            if (brand.loaded) {
                return brand;
            } else {
                var brandTree = null;

                for (var i in brand.brands) {
                    if (brandTree) {
                        break;
                    }
                    var childBrand = brand.brands[i];
                    brandTree = getTreeRootBrand(childBrand) || brandTree;
                }
                return brandTree;
            }
        };

        var getBrand = function (brandId, searchMode) {
            var defer = $q.defer();

            if (self.brandMappings[brandId] && (self.brandMappings[brandId].type === 'child' || self.brandMappings[brandId].loaded)) {
                defer.resolve(self.brandMappings[brandId]);
            } else {


                if (self.brandMappings[brandId]) {
                    self.brandMappings[brandId].loading = true;
                }

                var returnMap = {};

                var promise = self.onLoadBrand({
                    'brandId': brandId,
                    'returnMap': returnMap,
                    'includeArchived': self.includeArchivedLocations,
                }) || returnMap['promise'];

                if (!promise) {
                    promise = BrandAPI.getBrandsTree(brandId, false, false, null, false, self.includeArchivedLocations);
                }

                promise.then(function (tree) {

                    brandId = tree.id || brandId;
                    self.brandMappings[brandId] = self.brandMappings[brandId] || {};
                    self.brandMappings[brandId].loaded = true;
                    self.brandMappings[brandId].brand_id = brandId;

                    var isBrandSelected = self.brandMappings[brandId].selected;
                    var brandOldChilds = self.brandMappings[brandId].brands;
                    $.extend(self.brandMappings[brandId], tree);

                    if (isBrandSelected) {
                        self.brandMappings[brandId].selected = true;
                        self.brandMappings[brandId].partially_selected = false;
                    }

                    if (self.separateEnterprise &&
                        !self.brandMappings[brandId].dontSeparate &&
                        self.brandMappings[brandId].type === 'enterprise') {

                        self.brandMappings['child_' + tree.id] = {
                            id: 'child_' + tree.id,
                            name: tree.name,
                            type: 'child',
                            brand_id: brandId,
                            parent_id: brandId,
                            children_access_status: tree.children_access_status,
                            access_type: tree.access_type
                        };

                        self.brandMappings[brandId].brands.splice(0, 0, self.brandMappings['child_' + tree.id]);
                    }

                    for (var i in self.brandMappings[brandId].brands) {
                        var newChildBrand = self.brandMappings[brandId].brands[i];
                        for (var j in brandOldChilds) {
                            var oldChildBrand = brandOldChilds[j];
                            if (newChildBrand.id === oldChildBrand.id) {
                                newChildBrand.selected = oldChildBrand.selected;
                                newChildBrand.partially_selected = oldChildBrand.partially_selected;
                                newChildBrand.brands = oldChildBrand.brands;
                            }
                        }
                    }

                    var parentSelected = self.brandMappings[brandId].selected;

                    for (var i in self.brandMappings[brandId].brands) {
                        var childBrand = self.brandMappings[brandId].brands[i];
                        childBrand.parent_id = brandId;
                        childBrand.selected = childBrand.selected || !self.singleSelect && parentSelected;

                        if (!childBrand.brand_id) {
                            childBrand.brand_id = childBrand.id;
                        }

                        if (searchMode && self.brandMappings[childBrand.id]) {
                            if (childBrand.type !== 'child') {
                                childBrand.brands = self.brandMappings[childBrand.id].brands || childBrand.brands || [];
                            }
                            childBrand.active = self.brandMappings[childBrand.id].active || childBrand.active;
                        }

                        self.brandMappings[childBrand.id] = childBrand;
                    }

                    defer.resolve(self.brandMappings[brandId]);
                })
                    .catch(function (err) {
                        console.error(err);
                    })
                    .finally(function () {
                        delete self.brandMappings[brandId].loading;
                        self.onBrandMappingsChange({'brand_mappings': angular.copy(self.brandMappings)});
                    });
            }


            return defer.promise;
        };

        self.canExpandTree = function(brand){
            return brand.type !== 'child' && !(brand.type === 'enterprise' && self.enterpriseLevelOnly === true);
        };

        var scrollIntoView = function (brandTreeLevel, brandId) {
            var brandLevel = $element.find('#level_' + brandTreeLevel);
            var matchedBrand = $element.find('#brand_' + brandId);
            if (brandLevel.length && matchedBrand.length) {
                var matchedBrandTop = $(matchedBrand).offset().top;
                var brandLevelScrollTop = $(brandLevel).scrollTop();
                var newScrollTop = matchedBrandTop - $(brandLevel).offset().top + brandLevelScrollTop;
                $(brandLevel).scrollTop(newScrollTop);
            }
        };

        var onBrandPathClicked = function (index) {
            var brandPath = brandNavigatorService.searchBrandsData.brands[index];
            var brandTreePromises = {};
            var parentBrandsWithAccess = brandPath.parents || [];
            var highestBrandId = self.brandId;

            resetActiveBrands(FIRST_TREE_LEVEL);

            //When searching for root brand tree
            if (brandPath.id == highestBrandId) {
                return;
            }

            self.loadingBrandPath = true;

            for (var j = 0; j < parentBrandsWithAccess.length; j++) {
                var brand = parentBrandsWithAccess[j];
                var level = parentBrandsWithAccess.length - j - 1;
                brandTreePromises['brand_tree_' + brand.id] = self.setActive(level, brand.id, true);
            }

            $q.all(brandTreePromises)
                .catch(function (err) {
                    console.error(err);
                })
                .finally(function () {
                    self.activeLevels = filterActiveLevels(self.activeLevels, parentBrandsWithAccess.length - 1);
                    if (self.brandMappings[brandPath.id]) {
                        self.brandMappings[brandPath.id].activeSearchResult = true;
                    }

                    $timeout(function () {
                        for (var l = 0; l < parentBrandsWithAccess.length; l++) {
                            var parentBrandLevel = parentBrandsWithAccess.length - l - 1;
                            scrollIntoView(parentBrandLevel, parentBrandsWithAccess[l].id);
                        }
                        scrollIntoView(parentBrandsWithAccess.length, brandPath.id);
                    }, 500);

                    self.onSearchTreeLoaded && self.onSearchTreeLoaded({'brand_mappings': self.brandMappings});

                    // update Children Recursively for selected brands
                    if (self.ngModel && self.ngModel.length) {
                        for (var i = 0; i < self.ngModel.length; i++) {
                            var selectedBrand = self.ngModel[i];
                            updateChildrenRecursive(selectedBrand.id);
                        }
                    }

                    self.loadingBrandPath = false;
                    $scope.$evalAsync();
                });
        };

        self.assignHandlers = function (element) {
            element.find('.brand-path').unbind('click');
            element.find('.brand-path').on('click', function (event) {
                self.searchTerm = '';
                $scope.$evalAsync();
                var clickedElement = $(this);
                var rowIndex = clickedElement.data('row-index');
                onBrandPathClicked(rowIndex);
            });
        };

        self.onReachBottom = function () {
            if (self.loadingSearchResults) {
                return;
            }

            self.loadSearchBrandsResults();
        };

        self.loadSearchBrandsResults = function (isFirstLoad) {
            self.loadingSearchResults = true;
            self.isFirstLoad = isFirstLoad;

            if (isFirstLoad) {
                brandNavigatorService.reset();
            }

            if (
                self.searchTerm &&
                (brandNavigatorService.searchBrandsData.total === -1 || brandNavigatorService.searchBrandsData.brands.length < brandNavigatorService.searchBrandsData.total)
            ) {
                brandNavigatorService.getSearchBrandsResultsViewData(self.brandId, self.searchTerm, self.includeArchivedLocations)
                    .then(function (results) {
                        self.searchResults = results;
                        self.searchResultsCount = brandNavigatorService.searchBrandsData.total;
                    })
                    .catch(function (err) {
                        console.error(err);
                    })
                    .finally(function () {
                        self.loadingSearchResults = false;
                        self.isFirstLoad = false;
                        self.viewTrigger = !self.viewTrigger;
                    });
            } else {
                self.loadingSearchResults = false;
                self.isFirstLoad = false;
                self.loadingBrandTree = true;
                self.activeLevels = [];
                initBrandNavigatorTree();
            }
        };

        self.onArchivedLocationsToggleChange = function () {
            self.onClosedLocationsToggleChange({includeArchived: self.includeArchivedLocations});
            if (self.searchTerm) {
                self.loadSearchBrandsResults(true);
            } else {
                self.loadingBrandTree = true;
                self.activeLevels = [];
                self.brandMappings = null;
                initBrandNavigatorTree();
            }
        };
    }
})();
